<template>
  <AppView class="gallery">
    <ul class="gallery__grid">
      <li class="gallery__item" v-for="(entry, index) in currentEntries" :key="index">
        <transition name="bounce" appear>
          <div class="gallery__entry" @click="popupEntry = entry">
            <div class="gallery__entry__thumbnail" :style="getEntryThumbnailStyle(entry.result.attachment)"></div>

            <div class="gallery__popup" v-if="popupEntry">
              <div class="gallery__popup__backdrop" @click.stop="popupEntry = null"></div>

              <transition name="bounce" appear>
                <div class="gallery__popup__entry">
                  <img :src="getEntryImageSrc(popupEntry.result.attachment)" />
                </div>
              </transition>
            </div>
          </div>
        </transition>
      </li>
    </ul>

    <div class="gallery__button" @click.prevent="showMoreEntries()" v-if="shouldShowButton"><span>{{ $t('gallery.more') }}</span></div>
  </AppView>
</template>

<script>
import ApiService from '@/services/ApiService.js';
import AppView from '@/components/AppView.vue';

export default {
  name: 'Gallery',
  components: {
    AppView,
  },

  async created() {
    const entries = await ApiService.getEntries({
      appId: this.$t('app.id'),
    });

    const filteredEntries = entries.reverse().filter(entry => entry.isConfirmed && entry.isFavorite);

    this.entries = filteredEntries;
  },

  data: () => ({
    entries: [],
    entriesPerLoad: 8,
    maxEntries: 8,
    popupEntry: null,
  }),

  computed: {
    currentEntries() {
      return this.entries.slice(0, this.maxEntries);
    },

    shouldShowButton() {
      return this.maxEntries < this.entries.length;
    }
  },

  methods: {
    showMoreEntries() {
      this.maxEntries = this.maxEntries + this.entriesPerLoad;
    },

    getEntryThumbnailStyle(url) {
      return {
        backgroundImage: `url('https://images.weserv.nl/?url=${url.replace(/^https?:\/\//, '')}&w=200')`,
      };
    },

    getEntryImageSrc(url) {
      return `https://images.weserv.nl/?url=${url.replace(/^https?:\/\//, '')}&w=500`;
    },
  },
};
</script>

<style lang="scss">
.gallery {
  &__grid {
    display: flex;
    flex-wrap: wrap;
  }

  &__item {
    flex: 1 1 25%;
    max-width: 25%;

    padding: 20px;
  }

  &__entry {
    width: 100%;
    padding: 5px;
    background-color: #ffffff;

    box-shadow: -6.7px 7.4px 17.2px 3.8px rgba(0, 0, 0, 0.17);

    border-radius: 5px;

    cursor: pointer;

    &__thumbnail {
      width: 100%;
      padding-top: 100%;

      background-size: cover;
      background-position: center center;
      background-repeat: no-repeat;
    }
  }

  &__popup {
    position: fixed;
    z-index: 500;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    display: flex;
    align-items: center;
    justify-content: center;

    &__backdrop {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.5);
      cursor: pointer;
    }

    &__entry {
      position: relative;
      width: 100%;
      max-width: 600px;
      padding: 5px;
      background-color: #ffffff;

      box-shadow: -6.7px 7.4px 17.2px 3.8px rgba(0, 0, 0, 0.17);

      border-radius: 5px;

      cursor: default;

      img {
        display: block;
        width: 100%;
        height: auto;
      }
    }
  }

  &__button {
    max-width: 400px;
    margin: 20px auto;
    padding: 25px 50px 25px 60px;

    background-color: #0e76bc;

    transform: skewX(-20deg);
    transform-origin: bottom left;

    cursor: pointer;

    span {
      position: relative;
      display: block;
      font-size: 26px;
      font-weight: bold;
      text-decoration: none;
      text-transform: uppercase;
      text-align: center;
      color: inherit;

      transform: skewX(20deg);
      transform-origin: bottom left;
    }

    &:hover span {
      color: #ffff00;
    }
  }

}
</style>
